import React from 'react';
import Presets from './Presets';

export default function PublisherPresets({ product = null }) {
  return <Presets product={product} />;
}